import { getYear } from 'date-fns'

export const userIsUnder15 = (birthYear: number | string) => {
  return getYear(new Date()) - Number(birthYear) < 15
}
